import { makeStyles } from '@material-ui/styles'
import React from 'react'
import ListTable from 'core/components/listTable/ListTable'
import Info from 'core/components/validatedForm/Info'
import NumberedStepLabel from 'core/components/validatedForm/NumberedStepLabel'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import { humanReadableSize } from 'openstack/helpers'
import deleteVmStyles from './deleteVmStyles'

const useStyles = makeStyles<Theme>((theme) => ({
  ...deleteVmStyles(theme),
  emptyResourceText: {
    margin: theme.spacing(-3, 0, 0, 5.5),
  },
}))

const volumeColumns = [
  { id: 'name', label: 'Name', render: (value, item) => value || item?.id },
  { id: 'volume_type', label: 'Type' },
  { id: 'vm', label: 'VM' },
  { id: 'device_name', label: 'Device' },
  {
    id: 'volume_size',
    label: 'Size',
    render: (size) => humanReadableSize(size * 1024 * 1024 * 1024),
  },
  { id: 'bootable', label: 'Bootable', render: (value) => (value ? 'true' : 'false') },
]

const portColumns = [
  { id: 'name', label: 'Name', render: (value, item) => value || item?.id },
  { id: 'networkName', label: 'Network Name' },
  { id: 'ipAddress', label: 'IP Address' },
  { id: 'vm', label: 'VM' },
]

export default function DetailedSelection({
  vmVolumes,
  volumesToDelete,
  setVolumesToDelete,
  vmPorts,
  portsToDelete,
  setPortsToDelete,
}) {
  const classes = useStyles()
  return (
    <div className={classes.detailedContainer}>
      <Info className={classes.info}>
        <Text variant="subtitle2">Selected resources will be deleted with the VMs</Text>
        <Text variant="body2">
          Resources set to delete on termination are selected by default.
          <br />
          Select any additional resources you want to delete.
        </Text>
      </Info>
      <NumberedStepLabel step={1} title="Volumes selected for deletion" greyscale />
      {vmVolumes?.length > 0 ? (
        <ListTable
          onSelectedRowsChange={setVolumesToDelete}
          columns={volumeColumns}
          data={vmVolumes}
          selectedRows={volumesToDelete}
          checkboxCond={(volume) => !volume?.delete_on_termination}
          checkboxCondMessage="This volume is already marked for deletion within volume termination settings"
          uniqueIdentifier="id"
          searchTargets={['name', 'volume_type']}
          showCheckboxes
          multiSelection
        />
      ) : (
        <Text className={classes.emptyResourceText} variant="body2">
          No volumes associated with the VM(s)
        </Text>
      )}
      <NumberedStepLabel step={2} title="Ports selected for deletion" greyscale />
      {vmPorts?.length > 0 ? (
        <ListTable
          onSelectedRowsChange={setPortsToDelete}
          columns={portColumns}
          data={vmPorts}
          selectedRows={portsToDelete}
          checkboxCond={(port) => !port?.delete_on_termination}
          checkboxCondMessage="This is a DHCP port and will be automatically deleted"
          uniqueIdentifier="id"
          searchTargets={['name', 'ipAddress']}
          showCheckboxes
          multiSelection
        />
      ) : (
        <Text className={classes.emptyResourceText} variant="body2">
          No ports associated with the VM(s)
        </Text>
      )}
    </div>
  )
}
